import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
import { useAuthenticationStatus, useUserId } from '@nhost/nextjs'

import { Button, Text } from 'components/atomic'
import ImageMasthead from 'components/image-masthead'
import { useAddUserFlagsMutation, useUserMetadataQuery } from 'generated/graphql'
import styles from './index.module.scss'

const SS7RaffleSignupPage = () => {
  const router = useRouter()
  const { isAuthenticated } = useAuthenticationStatus()
  const userId = useUserId()
  const { data: userData } = useUserMetadataQuery()
  const [addToSS7RaffleSignUpList, { loading }] = useAddUserFlagsMutation()

  const [isSS7RaffleSignedUp, setIsSS7RaffleSignedUp] = useState(false)

  useEffect(() => {
    const user = userData?.users_metadata[0]
    if (!user) return

    if (user.flags?.ss7RaffleSignedUp) {
      setIsSS7RaffleSignedUp(true)
    }
  }, [userData?.users_metadata])

  const handleAddToSS7RaffleSignUpList = async () => {
    if (isAuthenticated) {
      try {
        await addToSS7RaffleSignUpList({
          variables: {
            userId,
            flagsValue: { ss7RaffleSignedUp: 1 },
          },
        })
        setIsSS7RaffleSignedUp(true)
      } catch (error) {
        console.error('addToSS7RaffleSignUpList error:', error)
      }
    } else {
      router.push(`/login?redirect=${encodeURIComponent('/ss7-raffle-signup')}`)
      // window.location.href = `/login?redirect=${encodeURIComponent('/creative')}`
    }
  }

  return (
    <ImageMasthead image="/images/ss7-raffle-signup/masthead.png" className="!max-h-[412px] !min-h-[412px]">
      <div className="flex flex-col	items-center pt-32">
        <div className="mb-5 h-[100px] w-[100px] rounded-full border border-white bg-[rgba(0,_0,_0,_0.5)]">
          <Image src="/images/events/vii_icon_a.png" layout="responsive" width={1} height={1} alt="SS7 Logo" />
        </div>
        <Text variant="h2" className="text-center">
          Operation Deadrop:
          <br />
          road to vegas
        </Text>

        <div className="mt-8 w-full max-w-[558px]">
          <div className="mb-[5px] h-[5px] w-full bg-[#D9D9D9] opacity-20" />
          <div className={styles.frame}>
            <Text variant="h3" className="px-[23px] py-6 text-center !text-h3 sm:px-[46px] sm:text-left">
              Free trip to Vegas for Snapshot VII?
            </Text>

            <Text variant="p2" className="px-[26px] opacity-70 sm:px-[52px]">
              Requirements:
              <ul className="ml-6 list-disc">
                <li>Must be 18 and older</li>
                <li>Must reside in United States or Canada</li>
                <li>User must opt in by 11:59pm PT on September 4th, 2023</li>
                <li>Must complete at least 1 listed Challenge to enter the Raffle</li>
                <li>Each Challenge can only be completed once for 1 raffle ticket</li>
                <li>Complete multiple Challenges to earn more Raffle Tickets!</li>
              </ul>
              <br />
              Opt in below to take part in the Challenge
            </Text>

            <div className="mt-8 flex justify-center px-[52px]">
              <Button
                variant="primary"
                onClick={handleAddToSS7RaffleSignUpList}
                disabled={true || isSS7RaffleSignedUp || loading}
                state={true || isSS7RaffleSignedUp || loading ? 'disabled' : ''}
              >
                <Text variant="button" tag="span">
                  {isSS7RaffleSignedUp ? 'You’re in!' : 'Challenge ended'}
                </Text>
              </Button>
            </div>

            <Text variant="p2" className="mb-10 mt-8 px-3 text-center opacity-70">
              Complete Challenges listed below between 12:00am PT on Aug 25th - 11:59pm PT on Sept 4th 2023 to earn
              Raffle tickets for chance to win a Free Trip* to VEGAS!
            </Text>

            <Text variant="p2" className="px-[26px] sm:px-[52px]">
              Overall Challenges (8/25-9/4)
              <ul className="ml-6 list-disc">
                <li>Extract on Sector 3</li>
                <li>Extract on Proving Ground 2</li>
                <li>DEADROP on Sector 3</li>
                <li>DEADROP on Proving Ground 2</li>
                <li>Kill 5 Claws</li>
                <li>Kill 20 Cleaners</li>
                <li>Die to a Claw</li>
                <li>Die to a Cleaner</li>
              </ul>
              <br />
            </Text>

            <Text variant="p2" className="px-3 sm:px-7">
              Stay tuned to the Discord for new Daily Challenges throughout the event!
            </Text>

            <Text variant="body2" className="px-3 py-12 uppercase opacity-80 sm:px-7">
              *two (2) winners will be drawn from the raffle, and will each win an $850 USD travel stipend to attend
              Snapshot 7 reveal in Las vegas - exclusions apply. See{' '}
              <a
                href="/docs/Road_to_Vegas_Challenges_Terms_and_Conditions.pdf"
                className="text-secondary hover:underline"
                target="_blank"
              >
                full terms and conditions
              </a>
            </Text>
          </div>
        </div>
      </div>
    </ImageMasthead>
  )
}

export default SS7RaffleSignupPage
